class AddRoleModalController {
  constructor($scope, $uibModalInstance, $rootScope, $http) {
    'ngInject';

    $scope.role = {
      roleName: '',
      roleDescription: '',
      text: ''
    };
    $scope.errorMessage = '';

    $scope.cancel = function () {
      $uibModalInstance.dismiss();
    };

    $scope.missingRequiredValues = function () {
      return !$scope.role.roleName;
    };

    $scope.addRole = function () {
      if ($scope.missingRequiredValues()) {
        return;
      }

      $http.post($rootScope.apiHost + '/api/admin/roles', $scope.role, {withCredentials: true}).then(function (success) {
        $uibModalInstance.close(success.data);
      }, function (failure) {
        $scope.errorMessage = (failure.data && failure.data.message) ? failure.data.message : 'Could not create role.';
      });
    };
  }
}

export default AddRoleModalController;



// WEBPACK FOOTER //
// ./client/pages/admin/role-management/modals/addRoleModal/addRoleModal.controller.js